import { type FC, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { parseRedirectPayload } from "src/common/feishu-login";


// Feishu hidden iframe callback bridge.
const Redirect: FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const payload = parseRedirectPayload(searchParams);

    if (window.parent && window.parent.onCodeReceived) {
      window.parent.onCodeReceived(payload);
    } else {
      console.warn("window.parent.onCodeReceived not received!");
    }
  }, [searchParams]);

  return (
    <div>
      Redirecting...
    </div>
  );
};


export default Redirect;
